export function reviewResponseBody(review:any){
    return `<div class="review-response mobile-left-align">
                <h3 class="response-party">
                    Response from <span class="response-party-author">${review.reviewResponseName}&nbsp;</span>
                </h3>
                <q>${review.reviewResponseBody}</q>
            </div>`
}